import * as MUI from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SINGLE_CLINIC_USER } from "../../../../enums/UrlPaths";
import { trimText } from "../../../../utils/Functions";
import { TABLE_CELL_ALIGNMENT } from "../enums/UserTableHeaderColumns";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import React from "react";
import { useTranslation } from "react-i18next";

export default function TableRowBody({ visibleRows = [], tableFields, testIdPrefix }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mode } = React.useContext(ThemeContext);
  const bgColorOfRow = mode == "dark" ? "black" : "#f5f3f4";

  return (
    <MUI.TableBody>
      {visibleRows.map((data, index) => (
        <MUI.TableRow
          hover
          onClick={(event) => navigate(SINGLE_CLINIC_USER + data.id)}
          key={data.id}
          tabIndex={-1}
          data-testid={testIdPrefix && `${testIdPrefix}.row.${data.id}`}
          sx={{ cursor: "pointer", bgcolor: index % 2 == 0 ? bgColorOfRow : "" }}
        >
          {tableFields.map((field) => (
            <MUI.TableCell
              key={field}
              align={TABLE_CELL_ALIGNMENT}
              data-testid={testIdPrefix && `${testIdPrefix}.row.${data.id}.${field}`}
              sx={{
                wordWrap: "break-word",
                color: data?.active ? "" : "orange",
              }}
            >
              {trimText(
                field === "numberOfPets"
                  ? `${data?.numberOfPets} (${t("ActivePets")}: ${data?.numberOfActivePets})`
                  : data?.[field],
              )}
            </MUI.TableCell>
          ))}
        </MUI.TableRow>
      ))}
    </MUI.TableBody>
  );
}
